<script lang="ts">
	export let value: string | undefined = undefined
	import type { i18n } from 'types/common'
	import { getContext } from 'svelte'
	const { t: translate } = getContext<i18n>('i18next')
</script>

{#if value}
	{value}
{:else}
	<i class="text-muted">{translate('common:notSlashAcceptable', 'N/A')}</i>
{/if}
